module.exports = __webpack_public_path__ + "static/media/eneco-bw.b6c31f53.jpg";